import {injectable} from 'inversify';

import {RootState} from './State';
import {Store, Init} from './Store';
import {LaunchBarInitialState} from './partials/LaunchBar';
import {WorkspacesStateInitial} from './partials/Workspaces';
import {AuthenticationInitialState} from './partials/Authentication';
import {OrganizationInitialState} from './partials/Organization';
import {DirectoryInitialState} from './partials/Directory';
import {SettingsInitialState} from './partials/Settings';
import {SearchEnginesInitialState} from './partials/SearchEngines';
import {ChannelManagerInitialState} from './partials/ChannelManager';

@injectable()
export class ServiceStore extends Store<RootState> {
    private static readonly INITIAL_STATE: RootState = {
        directory: DirectoryInitialState,
        searchEngines: SearchEnginesInitialState,
        authentication: AuthenticationInitialState,
        channelManager: ChannelManagerInitialState,
        launchBar: LaunchBarInitialState,
        workspaces: WorkspacesStateInitial,
        organization: OrganizationInitialState,
        settings: SettingsInitialState
    };

    protected async init(): Promise<void> {
        this.dispatch(new Init(ServiceStore.INITIAL_STATE));
    }
}
